<template>
    <div>
        <div class="modal-boddy">
            <div class="modal-text">
                <div class="text-justify">
                    <span>
                        A Empresa {{fornecedorAceite.razaoSocialFornecedor}}, inscrita no CNPJ
                        {{fornecedorAceite.cnpjFornecedor | az-cpf-cnpj}}, sediada na cidade de:
                        {{fornecedorAceite.municipioFornecedor}} - {{fornecedorAceite.ufFornecedor}},
                        {{fornecedorAceite.logradouroFornecedor}} - {{fornecedorAceite.numLogradouroFornecedor}},
                        telefone: {{fornecedorAceite.telefoneFornecedor | az-phone}}, neste ato representado por
                        seu(sua) sócio(a)/representante, o(a) Sr(a) {{fornecedorAceite.nomeUsuario}}, CPF
                        {{fornecedorAceite.cpfUsuario | az-cpf-cnpj}} e email: {{fornecedorAceite.emailUsuario}}, com
                        poderes estabelecidos no ato de investidura, declara sob as penas previstas na {{leiAmparoLegal}},
                        reunir todos os requisitos exigidos no ato convocatório para a habilitação,
                        quanto às condições de qualificação jurídica, técnica, econômica financeira, fiscal e
                        trabalhista.
                    </span>
                </div>
                <v-layout row wrap>
                    <v-flex xs12 sm4 md4></v-flex>
                    <v-flex xs12 sm8 md8>
                        <v-checkbox
                                :label="`Li e concordo com os termos acima.`"
                                v-model="aceitouTermos"
                                color="primary"
                        ></v-checkbox>
                    </v-flex>
                </v-layout>
            </div>
        </div>

        <div class="modal-actions__steps">
            <v-btn color="primary" outline @click="$emit('voltar')" class="btn-voltar">Voltar</v-btn>
            <span>Passo {{passoAtual}}/{{quantidadePassos}}</span>
            <v-btn color="primary" @click="$emit('proximo')" :disabled="!aceitouTermos" class="btn-finalizar">{{ passoAtual === quantidadePassos ? 'Finalizar' : 'Avançar'}}</v-btn>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: 'LicitacaoFornecedorTermosHabilitacao',
        props:['passoAtual', 'quantidadePassos'],
        data() {
            return {
                aceitouTermos: false,
                leiAmparoLegal: 'LEI Nº 8.666, de 21 de junho de 1993'
            }
        },
        computed: {
            ...mapState(['fornecedorAceite', 'licitacao'])
        },
        mounted() {
          this.setarLeiAmparoLegal()
        },
        methods: {
            setarLeiAmparoLegal(){
                if(this.licitacao.amparoLegal){
                    this.leiAmparoLegal = this.licitacao.amparoLegal.lei
                }
          }
        }
    }
</script>
